import styled from 'styled-components';
import { StockCardStyledOV } from './StockCardStyled.OV';

export const StockCardStyledOVGB = styled(StockCardStyledOV)`
    height: 100%;
`;
